import { AddToCalendarIcon, CircleCheckIcon } from "../../../../components/Icons";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../../config/params";
import {
  useBookingAppointmentTypeStore,
  useBookingReasonsNavigation,
} from "../../../../hooks";

import { BookedDetailsCard } from "./BookedDetailsCard";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { PetAvatars } from "../../../../components";
/* eslint-disable max-len */
import React from "react";
import {
  StyledBookingFlowButton,
} from "../../BookingScheduleContainer/BookingScheduleContainer.style";
import { joinPetNames } from "../../../../components/MultiPetBanner/MultiPetBanner";
import {
  useAppointmentStore,
} from "../../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../../context/ModalContext";
import { useUrgentVisitStore } from "../../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { CUSTOMER_REFERRAL_SOURCES } from "../../../../navigation/params";

export const BookedStep = () => {
  const { bookingResponse, selectedPets, resetUrgentVisit, rescheduleAppointmentId } =
    useUrgentVisitStore();
  const { closeModal, openModal } = useModal();
  const {
    setSelectedPets, setReasonForVisit, setAppointmentsForm,
    setAppointmentResponse, setAppointmentDetails, setGroupedAppointments,
  } = useAppointmentStore();
  const { setBookingAppointmentType } = useBookingAppointmentTypeStore();
  const { resetReasonsNavigationStore } = useBookingReasonsNavigation();

  if (!bookingResponse) return null;

  const petNamesDisplay = joinPetNames(selectedPets.map((p) => p.name));

  const isReschedule = !!rescheduleAppointmentId;
  const bookedSubtitle = (
    <>
      {isReschedule ? "Appointment rescheduled for " : "Appointment booked for "}
      <span className="font-semibold">{petNamesDisplay}</span>
      {"!"}
    </>
  );

  const handleDone = () => {
    resetUrgentVisit();
    setSelectedPets([]);
    resetReasonsNavigationStore();
    setReasonForVisit({});
    setAppointmentsForm(null);
    setAppointmentDetails(null);
    setGroupedAppointments(null);
    setBookingAppointmentType(CREATE_BOOKING_TYPE.NORMAL_BOOKING);
    if (!rescheduleAppointmentId) {
      openModal(MODALS.QUICK_SHARE_UPSELL_MODAL, CUSTOMER_REFERRAL_SOURCES.AFTER_BOOKING);
    } else {
      closeModal();
    }
  };

  const handleAddToCalendar = () => {
    userActivityLogger(MIXPANEL_EVENTS.URGENT_VISIT_ADD_CALENDAR, {
      appointment_category: "urgent",
      pet_name: selectedPets.map((p) => p.name).join(","),
    });
    // Set booking response in appointment store so AddToCalendarModal can read it
    setAppointmentResponse(bookingResponse as any);
    openModal(MODALS.ADD_TO_CALENDAR);
  };

  return (
    <div className="h-full flex flex-col items-center pt-8 w-full">
      <div className="flex flex-col items-center gap-2 px-1 shrink-0 w-full">
        <PetAvatars
          petDetails={selectedPets}
          height={80}
          width={80}
        />
        <h3 className="grenette-pro font-semibold text-2xl leading-[28px] text-light-black">
          {"Woohoo!"}
        </h3>
        <p className="text-base text-light-black text-center">
          {bookedSubtitle}
        </p>
      </div>

      <div className="w-full px-1 mt-4 min-h-0 flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto -mr-[20px] pr-[20px]">
          <BookedDetailsCard booking={bookingResponse} />
        </div>
      </div>

      <div className="flex flex-col gap-3 items-center w-full pt-6 pb-8 px-1 shrink-0">
        <StyledBookingFlowButton
          color="primary"
          size="small"
          className="w-full"
          onClick={handleDone}
          startIcon={<CircleCheckIcon />}
        >
          {"Done"}
        </StyledBookingFlowButton>

        <button
          type="button"
          className="flex gap-2 items-center justify-center w-full
            py-3 text-sm font-semibold text-light-black cursor-pointer
            rounded-[6.25rem] bg-transparent
            hover:bg-gray-3 transition-colors"
          onClick={handleAddToCalendar}
        >
          <AddToCalendarIcon />
          {"Add to Calendar"}
        </button>
      </div>
    </div>
  );
};
